import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { Button, ButtonVariantType, JabraIcon } from '@gn-audio/jss-components';

import { useScrollToItem } from 'common/condensedMenu/scrollToItem';

type NavButtonProps = {
  variant: ButtonVariantType;
  size: 'xs' | 's' | 'm' | 'l';
  link?: LinkField;
  icon?: string;
  title: string;
};

const NavButton = ({ variant, size, link, icon, title }: NavButtonProps) => {
  const { scrollTo } = useScrollToItem();
  const { anchor, href, linktype } = link?.value || {};

  const buttonProps = {
    variant: variant || 'primary',
    size: size || 'm',
    ...(linktype !== 'anchor' && !anchor
      ? {
          asLink: true,
          href,
        }
      : {}),
    ...(linktype === 'anchor' && anchor
      ? {
          onClick: () => scrollTo(anchor, 'smooth'),
        }
      : {}),
    ...(icon
      ? {
          icon: <JabraIcon Icon={icons[icon as keyof typeof icons]} />,
          iconPlacement: 'right' as const,
        }
      : {}),
  };

  return <Button {...buttonProps}>{title}</Button>;
};

export default NavButton;
